module.exports = __webpack_public_path__ + "img/Beaufort Blueprint_T.04d6a7c9.png";